import { Component, forwardRef, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProductCategory } from '../../../models/product';
import { ProductApiService } from '../../../services/apis/product-api.service';

interface CheckableProductCategory extends ProductCategory {
  checked?: boolean;
  isIndeterminate?: boolean;
  children: CheckableProductCategory[];
}

@Component({
  selector: 'app-product-category-checker',
  imports: [MatCheckboxModule, FormsModule],
  templateUrl: './product-category-checker.html',
  styleUrl: './product-category-checker.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductCategoryChecker),
      multi: true,
    },
  ],
})
export class ProductCategoryChecker implements OnInit, ControlValueAccessor {
  value: number[] = [];
  categories: CheckableProductCategory[] = [];
  constructor(private productApi: ProductApiService) {}

  ngOnInit(): void {
    this.findProductCategories();
  }

  onCheckChanged(
    category: CheckableProductCategory,
    parent?: CheckableProductCategory
  ) {
    if (parent) {
      parent.checked = parent.children.every((c) => c.checked);
      if (!parent.checked) {
        parent.isIndeterminate = parent.children.some((c) => c.checked);
      } else {
        parent.isIndeterminate = false;
      }
    } else {
      for (const child of category.children) {
        child.checked = category.checked;
      }
    }
    this.onValueChanged();
  }

  onValueChanged() {
    this.value = [];
    for (const category of this.categories) {
      if (category.checked) {
        this.value.push(category.id);
      } else {
        for (const child of category.children) {
          if (child.checked) {
            this.value.push(child.id);
          }
        }
      }
    }
    this.onChange(this.value);
  }

  loading: boolean = false;
  async findProductCategories() {
    try {
      this.loading = true;
      this.categories = await this.productApi.findProductCategories();
      this.updateCategoryChecked();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  updateCategoryChecked() {
    for (const category of this.categories) {
      category.checked = false;
      category.isIndeterminate = false;
      for (const child of category.children) {
        child.checked = this.value.includes(child.id);
      }
      if (this.value.includes(category.id)) {
        category.checked = true;
        category.children.forEach((c) => (c.checked = true));
      } else {
        category.checked = category.children.every((c) => c.checked);
        if (!category.checked) {
          category.isIndeterminate = category.children.some((c) => c.checked);
        } else {
          category.isIndeterminate = false;
        }
      }
    }
  }

  onChange: (value: number[]) => void = () => {};
  onTouched: () => void = () => {};
  writeValue(value: number[]): void {
    this.value = value || [];
    this.updateCategoryChecked();
  }

  registerOnChange(fn: (value: number[]) => void): void {
    this.onChange = fn; // 注册外部的变更回调
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn; // 注册外部的触摸回调
  }

  disabled: boolean = false;
  // 可选：禁用组件
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
